import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PaginationControls = ({
  currentPage,
  setCurrentPage,
  totalPages,
  totalRecords,
  pageSize,
  isLoading
}) => {
  const start = totalRecords > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const end = Math.min(currentPage * pageSize, totalRecords);

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 sm:px-6 py-2">
      <span className="text-sm text-gray-600 truncate mr-2">
        {totalRecords === 0
          ? '0 results'
          : `${start}–${end} of ${totalRecords}`}
      </span>
      <div className="flex items-center gap-1 shrink-0">
        <button
          onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          disabled={currentPage === 1 || isLoading}
          className="p-1 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft size={16} />
        </button>
        <span className="px-1 text-sm text-gray-600 whitespace-nowrap hidden sm:inline">
          Page {currentPage} of {totalPages}
        </span>
        <span className="px-1 text-sm text-gray-600 sm:hidden">
          {currentPage}/{totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
          disabled={currentPage >= totalPages || isLoading}
          className="p-1 rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
